export const FORGE_INFERENCE_PATH = '/forge/inference';
export const FORGE_INFERENCE_GETTING_STARTED_PATH = `${FORGE_INFERENCE_PATH}/getting-started`;
export const FORGE_INFERENCE_QUICKSTART_PATH = `${FORGE_INFERENCE_PATH}/quickstart`;
export const FORGE_INFERENCE_MODELS_PATH = `${FORGE_INFERENCE_PATH}/models`;
export const FORGE_INFERENCE_MODEL_PATH = `${FORGE_INFERENCE_MODELS_PATH}/:modelId`;
export const FORGE_INFERENCE_MODEL_COMPARISON_PATH = `${FORGE_INFERENCE_PATH}/model-comparison`;
export const FORGE_INFERENCE_PLAYGROUND_PATH = `${FORGE_INFERENCE_PATH}/playground`;

export const FORGE_INFERENCE_PATHS = [
  FORGE_INFERENCE_GETTING_STARTED_PATH,
  FORGE_INFERENCE_QUICKSTART_PATH,
  FORGE_INFERENCE_MODELS_PATH,
  FORGE_INFERENCE_MODEL_PATH,
  FORGE_INFERENCE_MODEL_COMPARISON_PATH,
  FORGE_INFERENCE_PLAYGROUND_PATH,
];

export const getForgeInferenceModelPath = (modelId: string) =>
  `${FORGE_INFERENCE_MODELS_PATH}/${encodeURIComponent(modelId)}`;
